import React from 'react';
import '../App.css';
import { Link } from 'react-router-dom';

export default function Navbar() {
    return (
        <header>

            <nav className="navbar navbar-expand-lg sticky-top">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-2 col-8">
                            <Link to="/" className="navbar-brand">
                                <img src='images/logo.png' alt='img' height="100" />
                            </Link>
                        </div>

                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#main_nav"
                            aria-controls="main_nav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className='col-md-10'>
                            <div className="col-md-12 m-none">
                                <div className="main-nav__header-one__top clearfix">
                                    <div className="main-nav__header-one__top-left">
                                        <ul className="list-unstyled">
                                            <li>
                                                <div className="icon">
                                                    <i className="fas fa-phone-square-alt"></i>
                                                </div>
                                                <div className="text">
                                                    <p><a href="tel:91 99480 61999"> +91  <span className="num-pr">99480 </span> <span className="num-pr"> 61999</span> </a></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <i className="fas fa-envelope"></i>
                                                </div>
                                                <div className="text">
                                                    <p><a href="mailto:help@kbkwelfareassociation.com">help@kbkwelfareassociation.com</a></p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="main-nav__header-one__top-right">
                                        <div className="main-nav__header-one__top-social">
                                            <a className='facebook' target="_blank" href="https://www.facebook.com/KBK-Welfare-Association-101633825494305"><i className="fab fa-facebook-square"></i></a>
                                            <a
                                                className="twitter"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href="https://twitter.com/kbkwelfare"
                                            >
                                                <i className="fa-brands fa-x-twitter"></i>
                                            </a>

                                            <a className='instagram' target="_blank" href="https://www.instagram.com/kbkwelfare/"><i className="fab fa-instagram"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="collapse navbar-collapse" id="main_nav">
                                    <ul className="navbar-nav mb-2 mb-lg-0">
                                        <li className="nav-item">
                                            <Link to="/" className="nav-link">Home</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/about" className="nav-link">About Us</Link>
                                        </li>
                                        <li className="nav-item dropdown">
                                            <Link
                                                to="#"
                                                className="nav-link dropdown-toggle"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                Our Work
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                <li><Link to="food-distribution" className="dropdown-item">Food Distribution</Link></li>
                                                <li><Link to="grocery" className="dropdown-item">Grocery Distribution</Link></li>
                                                <li><Link to="school-stationary" className="dropdown-item">School Stationary</Link></li>
                                                <li><Link to="cloth-distribution" className="dropdown-item">Cloths Distribution</Link></li>
                                                <li><Link to="covid-19" className="dropdown-item">Covid - 19 Essentials</Link></li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <ul className="navbar-nav">
                                        <li className="nav-item">
                                            <Link to="gallery" className="nav-link">Events Gallery</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="news" className="nav-link">News</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="partner-with-us" className="nav-link">Partner With Us</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="contact" className="nav-link">Contact</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
}
